import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

export const checkSalesFeatureFlag: HermesGuardFn = async (to) => {
  if (to.name !== 'brand.sales') return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.salesDashboard')) {
    return {
      name: 'brand.home',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
